import React, { useEffect, useRef } from 'react';
import { styled } from 'sensortower-components/src/utils/styled';
import ErrorBoundary from 'sensortower-components/src/base-components/ErrorBoundary';
import { sidekick } from '../../utils/sidekick';

export interface ModuleIntegrationInfogramProps {
  id?: string;
  settings?: {
    id?: string;
  };
  sidekickLookup: any;
}

const ModuleIntegrationInfogram = ({ sidekickLookup, settings }: ModuleIntegrationInfogramProps) => {
  const infogramRef = useRef<HTMLDivElement>(null);
  const infogramId = settings?.id;

  // Load Infogram script
  useEffect(() => {
    const scriptElement = document.createElement('script');

    if (window['InfogramEmbeds']?.initialized) {
      window['InfogramEmbeds'].process();
    } else {
      scriptElement.src = 'https://e.infogram.com/js/dist/embed-loader-min.js';
      scriptElement.async = true;
      scriptElement.id = 'infogram-async';

      document.body.appendChild(scriptElement);
    }

    return () => {
      if (document.body.contains(scriptElement)) {
        document.body.removeChild(scriptElement);
      }
    };
  }, []);

  if (!infogramId) return null;

  return (
    <ErrorBoundary>
      <Root {...sidekick(sidekickLookup)} data-testid="ModuleIntegrationInfogram">
        <InfogramEmbed
          className="infogram-embed"
          data-id={infogramId}
          data-type="interactive"
          data-title=""
          ref={infogramRef}
        />
      </Root>
    </ErrorBoundary>
  );
};

export default ModuleIntegrationInfogram;

const Root = styled('div', {
  name: 'ModuleIntegrationInfogram',
})(() => ({
  // To be 100% accurate, we'd have to subtract the heights of the header, announcement banner and footer.
  // As Infogram reports are usually multi-page, they are higher than all viewports anyway.
  minHeight: '100vh',
}));

const InfogramEmbed = styled('div')`
  display: flex;
`;
